import { MasterButton } from "App/Component/ui";
import { instance3 } from "App/constants";
import {
  today,
  isNull,
  defaultToastError,
  oneMonthAfterToday,
} from "App/utils/helpers";
import { requiredMsg } from "App/utils/validation";
import fileDownload from "js-file-download";
import moment from "moment";
import "moment/locale/id";
import { useState } from "react";
import { getRekapTagihanById } from "../../DaftarRekapTagihan/helpers";
import { lastOfDay, startOfDay } from "utils/dates";

// const urlGetRekapTagihanById = "/rekap-tagihan/details-by-id";
// const urlGetRekapTagihanById = "/rekap-tagihan/details-v2-by-id";
export const urlGetJenisLayanan = "/typeofcare/listtypeofcare";
export const urlGetAsuransi = "/insurance/listinsurance_itgh";
export const urlAddTagihan = "/rekap-tagihan/add";

export const urlAddKunjungan = "/poolKunjungan/register";
export const urlGetKunjunganByTagihanId = "/poolKunjungan/list";

export const urlExportExcel = "/rekap-tagihan/rekap-excel";
export const urlExportPDF = "/rekap-tagihan/rekap-pdf";
export const urlExportKwintansi = "/rekap-tagihan/kwitansi";

export const STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA = "0";
export const STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI = "1";
export const STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP = "2";

export const RenderStatusRekapTagihan = ({ status }) => {
  if (status === STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"BUKA"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"KUNCI"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"TUTUP"}
        color={"danger"}
        type="button"
        disabled
      />
    );
  } else {
    return <></>;
  }
};

export const STATE_FILTER_TAGIHAN = {
  id_rekap: "",
  id_tagihan: "",
  guarantor_name: "",
  tanggal_awal: null,
  tanggal_akhir: null,
};

export const STATUS_PROSES_REKAP_TAGIHAN = [
  {
    label: "Tanpa Proses",
    value: 1,
  },
  {
    label: "Seluruh Tagihan Siap Ditutup",
    value: 2,
  },
  {
    label: "Seluruh Tagihan Berhasil Ditutup",
    value: 3,
  },
  {
    label: "Rekap Tagihan Gagal Ditutup",
    value: 4,
  },
];

export const JENIS_PENERIMA = [
  {
    label: "Asuransi",
    value: "Asuransi",
  },
  {
    label: "Perusahaan",
    value: "Perusahaan",
  },
];

export const RESET_STATE_REKAP_TAGIHAN = {
  rekap_tagihan_id: "",
  idgl: "",
  no_surat: "",
  no_resi: "",
  tanggal_rekap: today(true),
  tanggal_periode_awal: today(),
  tanggal_periode_akhir: today(),
  tanggal_tagih: today(),
  tanggal_jatuh_tempo: oneMonthAfterToday(),
  jenis_asuransi_id: "Asuransi",
  jenis_asuransi_nama: "ASURANSI",
  asuransi_id: "",
  asuransi_nama: "Pilih Asuransi",
  jenis_rawat_id: "",
  jenis_rawat_nama: "Pilih Jenis Rawat",
  status_proses: null,
  status_proses_id: 1,
  status_proses_name: "Tanpa Proses",
  reload: false,
  sisa_harga_tagihan: 0,
  total_harga_tagihan: 0,
  total_dibayar: 0,
  total_tagihan: 0,
  diskon: 0,
  total_diskon: 0,
  total_bayar_tagihan: 0,
  total_bayar_diskon: 0,
  nama_virtual_account: "",
  no_virtual_account: "",
  nama_bank: "",

  totalTagihan: {
    jumlah: 0,
    potongan: 0,
    tax: 0,
    total: 0,
    bayar: 0,
    sisa: 0,
  },

  rincianRekap: {
    total1: 0,
    diskon1: 0,
    sisa1: 0,

    total2: 0,
    bayar: 0,
    sisa2: 0,
  },
};

export const METODE_PEMBAYARAN = [
  {
    label: "Metode Pembayaran Langsung",
    value: 1,
  },
  {
    label: "Metode Pemabayaran Import",
    value: 2
  }
]

export const RESET_STATE_PEMBAYARAN = {
  id: "",
  tanggal_masuk: today(true),
  tipe_pembayaran_id: 1,
  kas_id: null,
  kas_name: "Pilih Kas",
  jumlah_bayar2: "",
  kartu_bank: "",
  kartu_bank_name: "Pilih Bank",
  no_kartu: "",
  no_transfer: "",
  coa_code: "",
  coa_name: "",
  no_kwitansi: "",
  total_harga: "",
  diskon: "",
  total_diskon: 0,
  total_bayar_diskon: 0,
  tipe_kartu: "",
  tipe_kartu_nama: "Pilih Tipe Kartu",
  isDiskon: false,
  asuransi_id: "",
  asuransi_nama: "",
  metode_pembayaran: 1
};

export const getDetailRekapTagihanById = async (id) => {
  try {
    const dataTagihan = await getRekapTagihanById(id);
    const dataDetailTagihan = await getDetailDataTagihanById(
      {
        id_rekap: id,
        id_tagihan: "",
        guarantor_name: "",
        tanggal_awal: "",
        tanggal_akhir: "",
      },
      1,
      10
    );

    if (dataTagihan.state) {
      if (dataDetailTagihan.state) {
        const res = dataTagihan;
        // const detail = res.detail;
        const detail = dataDetailTagihan.data;
        
        const datas = {
          state: true,
          data: {
            rekap_tagihan_id: res?.data.id,
            idgl: res?.data.idgl,
            no_surat: res?.data.no_surat,
            tanggal_rekap: res?.data.tanggal,
            tanggal_periode_awal: res?.data.tanggal_periode_awal,
            tanggal_periode_akhir: res?.data.tanggal_periode_akhir,
            tanggal_tagih: res?.data.tanggal_tagih,
            tanggal_jatuh_tempo: res?.data.tanggal_jatuh_tempo,
            jenis_asuransi_id: res?.data.penerima,
            jenis_asuransi_nama: res?.data.penerima,
            asuransi_id: res?.data.asuransi_id,
            asuransi_nama: res?.data.asuransi_name,
            jenis_rawat_id: res?.data.instalasi_id,
            jenis_rawat_nama: res?.data.insatasi_name,
            status_proses: res?.data.status_proses,
            status_proses_id: res?.data.status_proses,
            status_proses_name: res?.data.status_proses_name,
            no_resi: res?.data.no_resi,
            // detail: detail,
            reload: false,
            sisa_harga_tagihan: res?.data.sisa_harga_tagihan,
            total_harga_tagihan: res?.data.total_harga_tagihan,
            total_dibayar: res?.data.total_dibayar,
            total_tagihan: res?.data.total_tagihan,
            diskon: res?.data.diskon,
            total_diskon: res?.data.total_diskon,
            total_bayar_tagihan: res?.data.total_bayar_tagihan,
            total_bayar_diskon: res?.data.total_bayar_diskon,
            nama_virtual_account: res?.data.nama_virtual_account,
            no_virtual_account: res?.data.no_virtual_account,
            nama_bank: res?.data.nama_bank,
          },
          detail: detail,
          totalTagih: dataDetailTagihan.meta.count,
        };

        return datas;
      } else {
        return {
          state: false,
          data: [],
          totalTagih: 0,
          message: dataDetailTagihan.message,
        };
      }
    } else {
      return {
        state: false,
        data: [],
        totalTagih: 0,
        message: dataTagihan.message,
      };
    }

    // const data = await Promise.all([api, detailTagihan]).then((response) => {
    //   const dataTagihan = response[0];
    //   const dataDetailTagihan = response[1];
    //   Promise.resolve().then(async () => {
    
    //   });
    // });
    // console.log("data", data);
    // return data;

    // const res = api.data;

    // if (api.status === 200) {
    //   return {
    //     state: true,
    //     data: {
    //       rekap_tagihan_id: res.id,
    //       idgl: res.data?.idgl,
    //       no_surat: res.data?.no_surat,
    //       tanggal_rekap: res.data?.tanggal,
    //       tanggal_periode_awal: res.data?.tanggal_periode_awal,
    //       tanggal_periode_akhir: res.data?.tanggal_periode_akhir,
    //       tanggal_tagih: res.data?.tanggal_tagih,
    //       tanggal_jatuh_tempo: res.data?.tanggal_jatuh_tempo,
    //       jenis_asuransi_id: res.data?.penerima,
    //       jenis_asuransi_nama: res.data?.penerima,
    //       asuransi_id: res.data?.asuransi_id,
    //       asuransi_nama: res.data?.asuransi_name,
    //       jenis_rawat_id: res.data?.instalasi_id,
    //       jenis_rawat_nama: res.data?.insatasi_name,
    //       status_proses: res.data?.status_proses,
    //       status_proses_id: res.data?.status_proses,
    //       status_proses_name: res.data?.status_proses_name,
    //       no_resi: res.data?.no_resi,
    //       // detail: detail,
    //       reload: false,
    //       sisa_harga_tagihan: res.data?.sisa_harga_tagihan,
    //       total_harga_tagihan: res.data?.total_harga_tagihan,
    //       total_dibayar: res.data?.total_dibayar,
    //       total_tagihan: res.data?.total_tagihan,
    //       diskon: res.data?.diskon,
    //       total_diskon: res.data?.total_diskon,
    //       total_bayar_tagihan: res.data?.total_bayar_tagihan,
    //       total_bayar_diskon: res.data?.total_bayar_diskon,
    //       nama_virtual_account: res.data?.nama_virtual_account,
    //       no_virtual_account: res.data?.no_virtual_account,
    //       nama_bank: res.data?.nama_bank,
    //     },
    //     detail: res.data.detail,
    //   };
    // } else {
    //   return {
    //     state: false,
    //     message: res.data.message,
    //   };
    // }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getDetailPembayaranById = async (id, pages = 1, limit=10, id_bayar_rekap) => {
  try {
    // const api = await instance3.post("/rekap-tagihan/bayar-list", {
    //   id: "",
    //   rekap_tagihan_id: id,
    //   kas_id: "",
    //   tanggal_awal: "",
    //   tanggal_akhir: "",
    //   halaman: 1,
    //   jumlah: 100000,
    // });
    const api = await instance3.post("/rekap-tagihan/bayar-list", {
      id: id_bayar_rekap,
      rekap_tagihan_id: id,
      halaman: pages,
      jumlah: limit,
    });
    const res = api.data;

    if (api.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res?.count ?? 0),
          pages: parseInt(res?.pages ?? 0),
          limit: parseInt(res?.limit ?? 0),
        },
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};




export const getDetailDataTagihanById = async (formFilter, pages=1, limit=10) => {
  try {
    const api = await instance3.get(
      "/rekap-tagihan/list-detail-rekap-tagihan",
      {
        params: {
          pages: pages,
          limit: limit,
          id_rekap: formFilter.id_rekap,
          id_tagihan: formFilter.id_tagihan,
          guarantor_name: formFilter.guarantor_name,
          tanggal_awal: isNull(formFilter.tanggal_awal)
            ? ""
            : startOfDay(formFilter.tanggal_awal),
          tanggal_akhir: isNull(formFilter.tanggal_akhir)
            ? ""
            : lastOfDay(formFilter.tanggal_akhir),
        },
      }
    );
    const res = api.data;

    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.pages),
          limit: parseInt(res.limit),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getNotifRekapTagihan = async ({ id }) => {
  const tagihan = getRekapTagihanById(id);
  const pembayaran = getDetailPembayaranById(id);
  return await Promise.all([tagihan, pembayaran])
    .then((response) => {
      const dataTagihan = response[0];
      const dataPembayaran = response[1];
      if (dataTagihan.state) {
        if (dataPembayaran.state) {
          const datas = dataPembayaran.data;
          const res = dataTagihan.data;
          const detail = res.detail;
          const propsPageInputRekapTagihan = {
            formData: {
              rekap_tagihan_id: res.id,
              idgl: res?.idgl,
              no_surat: res?.no_surat,
              tanggal_rekap: res?.tanggal,
              tanggal_periode_awal: res?.tanggal_periode_awal,
              tanggal_periode_akhir: res?.tanggal_periode_akhir,
              tanggal_tagih: res?.tanggal_tagih,
              tanggal_jatuh_tempo: res?.tanggal_jatuh_tempo,
              jenis_asuransi_id: res?.penerima,
              jenis_asuransi_nama: res?.penerima,
              asuransi_id: res?.asuransi_id,
              asuransi_nama: res?.asuransi_name,
              jenis_rawat_id: res?.instalasi_id,
              jenis_rawat_nama: res?.insatasi_name,
              status_proses: res?.status_proses,
              status_proses_id: res?.status_proses,
              status_proses_name: res?.status_proses_name,
              no_resi: res?.no_resi,
              // detail: detail,
              reload: true,
              sisa_harga_tagihan: res?.sisa_harga_tagihan,
              total_harga_tagihan: res?.total_harga_tagihan,
              total_dibayar: res?.total_dibayar,
              total_tagihan: res?.total_tagihan,
              diskon: res?.diskon,
              total_diskon: res?.total_diskon,
              total_bayar_tagihan: res?.total_bayar_tagihan,
              total_bayar_diskon: res?.total_bayar_diskon,
            },

            detail: detail,

            pembayaran: datas,

            totalTagihan: {
              jumlah: 0,
              potongan: 0,
              tax: 0,
              total: 0,
              bayar: 0,
              sisa: 0,
            },

            rincianRekap: {
              total1: 0,
              diskon1: 0,
              sisa1: 0,

              total2: 0,
              bayar: 0,
              sisa2: 0,
            },
          };
          return propsPageInputRekapTagihan;
        } else {
          return defaultToastError(dataPembayaran.message);
        }
      } else {
        return defaultToastError(dataTagihan.message);
      }
    })
    .catch((error) => {
      return defaultToastError("Terjadi Kesalahan Saat Mengambil Data!");
    });
};

export const validationInputRekapTagihan = (formData) => {
  const errors = {};
  if (isNull(formData.jenis_asuransi_id)) {
    errors["jenis_asuransi_id"] = requiredMsg("Jenis Instansi");
  }

  if (isNull(formData.asuransi_id)) {
    errors["asuransi_id"] = requiredMsg("Asuransi");
  }

  if (isNull(formData.jenis_rawat_id)) {
    errors["jenis_rawat_id"] = requiredMsg("Jenis Rawat");
  }

  return errors;
};

export const getExportExcel = async (id) => {
  try {
    const api = await instance3.post(urlExportExcel, {
      id,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const exportPdf = async (formData, datas) => {
  try {
    const response = await instance3.post(
      urlExportPDF,
      {
        id: formData?.id,
        tanggal: moment(formData.tanggal_surat)
          .locale("id")
          .format("Do MMMM YYYY"),
        no_surat: datas?.no_surat,
        penerima: datas?.asuransi_nama,
        tanggal_periode_awal: moment(datas?.tanggal_periode_awal)
          .locale("id")
          .format("Do MMMM YYYY"),
        tanggal_periode_akhir: moment(datas?.tanggal_periode_akhir)
          .locale("id")
          .format("Do MMMM YYYY"),
        tanggal_kirim: moment(formData?.tanggal_kirim)
          .locale("id")
          .format("dddd, Do MMMM YYYY"),
        tanggal_jatuh_tempo: moment(datas?.tanggal_jatuh_tempo)
          .locale("id")
          .format("dddd, Do MMMM YYYY"),
        total_harga_tagihan: datas?.total_harga_tagihan,
        diskon: datas?.diskon,
        total_diskon: datas?.total_diskon,
        sisa_harga_tagihan: datas?.sisa_harga_tagihan,
        total_dibayar: datas?.total_dibayar,
        nama_virtual_account: datas?.nama_virtual_account,
        nama_bank: datas?.nama_bank,
        no_virtual_account: datas?.no_virtual_account,
      },
      {
        responseType: "blob",
      }
    );
    return {
      state: true,
      data: response.data,
    };
  } catch (error) {
    return {
      state: false,
      data: [],
      message: error?.response?.data?.message,
    };
  }
};

export const usePrintPdf = () => {
  const [loading, setLoading] = useState(false);

  const handleClickPDF = async (formData, datas) => {
    setLoading(true);
    const response = await exportPdf(formData, datas);
    if (response.state) {
      fileDownload(response.data, `Daftar Tagihan ${datas?.asuransi_nama}.pdf`);
      setLoading(false);
    } else {
      defaultToastError(response.message);
      setLoading(false);
    }
  };

  return {
    loadingPrint: loading,
    handleClickPDF: handleClickPDF,
  };
};

export const exportKwintansi = async (formData) => {
  try {
    const response = await instance3.post(
      urlExportKwintansi,
      {
        id: formData.id,
        tanggal: moment(formData.tanggal).locale("id").format("Do MMMM YYYY"),
        no_surat: formData.no_surat,
        penerima: formData.penerima,
        untuk_pembayaran: formData.untuk_pembayaran,
        nilai: formData.nilai,
        nilai2: formData.nilai2,
        terbilang: formData.terbilang,
        nama_virtual_account: formData?.nama_virtual_account,
        nama_bank: formData?.nama_bank,
        no_virtual_account: formData?.no_virtual_account,
      },
      {
        responseType: "blob",
      }
    );
    return {
      state: true,
      data: response.data,
    };
  } catch (error) {
    return {
      state: false,
      data: [],
      message: error?.response?.data?.message,
    };
  }
};

export const usePrintKwintansi = () => {
  const [loading, setLoading] = useState(false);

  const handleClickKwintansi = async (formData) => {
    setLoading(true);
    const response = await exportKwintansi(formData);
    if (response.state) {
      fileDownload(response.data, `Kwintansi ${formData.penerima}.pdf`);
      setLoading(false);
    } else {
      defaultToastError(response.message);
      setLoading(false);
    }
  };

  return {
    loadingPrint: loading,
    handleClickKwintansi: handleClickKwintansi,
  };
};

export const getLogById = async (id) => {
  try {
    const api = await instance3.post("/rekap-tagihan/list-log-rekap", {
      id: "",
      role: "",
      id_rekap: id,
    });
    const res = api.data;

    if (api.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCellsDataBerhasil = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "id_tagihan",
    disablePadding: true,
    label: "ID TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nama_rm",
    disablePadding: true,
    label: "NAMA RM",
    sort: false,
    align: "left",
    minWidth: "200px",
  },
  {
    id: "rm_id",
    disablePadding: true,
    label: "ID RM",
    sort: false,
    align: "left",
    minWidth: "130px",
  },
  {
    id: "tanggal_tagihan",
    disablePadding: true,
    label: "TGL TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status_tagihan",
    disablePadding: true,
    label: "STATUS TAGIHAN",
    sort: false,
    align: "center",
    minWidth: "130px",
  },
  {
    id: "asuransi",
    disablePadding: true,
    label: "ASURANSI",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_asuransi",
    disablePadding: true,
    label: "NO. ASURANSI",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "total_tagihan",
    disablePadding: true,
    label: "TOTAL TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "dibayar",
    disablePadding: true,
    label: "DIBAYAR",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "sisa",
    disablePadding: true,
    label: "SISA",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
];

export const headCellsDataGagal = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "id_tagihan",
    disablePadding: true,
    label: "ID TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "message",
    disablePadding: true,
    label: "KETERANGAN",
    sort: false,
    align: "left",
    minWidth: "200px",
  },
];